import { create } from "zustand";

export type ToastSeverity = "success" | "error" | "info" | "warning";

export interface Toast {
  id: number;
  message: string;
  severity: ToastSeverity;
}

interface UiState {
  toasts: Toast[];
  pending: number; // numero di chiamate API in corso → loader globale
  pushToast: (message: string, severity?: ToastSeverity) => void;
  dismissToast: (id: number) => void;
  startLoading: () => void;
  stopLoading: () => void;
}

let toastSeq = 0;

export const useUiStore = create<UiState>((set) => ({
  toasts: [],
  pending: 0,
  pushToast: (message, severity = "info") =>
    set((s) => ({ toasts: [...s.toasts, { id: ++toastSeq, message, severity }] })),
  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  startLoading: () => set((s) => ({ pending: s.pending + 1 })),
  stopLoading: () => set((s) => ({ pending: Math.max(0, s.pending - 1) }))
}));

// Helper utilizzabili fuori dai componenti React (es. nel client HTTP).
export const ui = {
  toast: (message: string, severity: ToastSeverity = "info") =>
    useUiStore.getState().pushToast(message, severity),
  start: () => useUiStore.getState().startLoading(),
  stop: () => useUiStore.getState().stopLoading()
};
